/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TpPopover from '@/components/NewVuxComponents/TpPopover';
import { orderStatusMapping, priorityMapping, statusColorMapping } from '@/constant';
import utils from '@/utils/utils';
export default {
  components: {
    TpPopover: TpPopover
  },
  props: {
    isCard: {
      type: Boolean,
      default: false
    },
    time: [String, Number],
    priority: [String, Number],
    ding: [String, Number],
    inside: [String, Number],
    abnormal: [String, Number],
    status: [String, Number],
    examine: [String, Number],
    moreOperation: {
      type: Array,
      default: function _default() {
        return [// { value: 'start', name: '开始服务' },
          // { value: 'ovor', name: '结束服务' },
          // { value: 'op', name: '定位' },
          // { value: 'assign', name: '指派' }
        ];
      }
    }
  },
  data: function data() {
    return {
      priorityMapping: priorityMapping,
      orderStatusMapping: orderStatusMapping,
      statusColorMapping: statusColorMapping,
      sourceIcon: {
        2: 'icon_h532_32@3x',
        3: 'icon_wechat32_32@3x',
        7: 'icon_ding32_32@3x'
      },
      nowTime: new Date().getTime(),
      mini: this.$parent.$parent.mini,
      // 是否是两行列表
      showImage: this.$parent.$parent.showImage,
      // 是否显示图片
      // 是否slot
      hasTempIcon: false,
      hasNo: false,
      hasTime: false,
      hasCustomer: false,
      hasAddress: false
    };
  },
  computed: {
    miniStyle: function miniStyle() {
      var miniStyle = {};

      if (this.mini) {
        // miniStyle.height = '4.8rem'
        miniStyle.padding = '.8rem 1rem';
        miniStyle.imgHeightWidth = '3.2rem';
        miniStyle.imgBorderRadius = '50%';
      } else {
        // miniStyle.height = '10.8rem'
        // miniStyle.height = '12.26rem'
        miniStyle.padding = '1rem 1rem';
        miniStyle.imgHeightWidth = '4.8rem';
        miniStyle.imgBorderRadius = '.24rem';
      }

      return miniStyle;
    },
    formatNowTime: function formatNowTime() {
      var timeStamp = new Date(utils.formatDate(this.time)).getTime();
      return this.formatTime((timeStamp - this.nowTime) / 1000);
    }
  },
  methods: {
    // 格式化逾期工单具体时间
    formatTime: function formatTime(second) {
      second = parseInt(second);
      var text = '';

      if (second < 0) {
        text += '逾期';
      } else {
        text += '距离服务时间';
      }

      second = parseInt(Math.abs(second));
      var day = parseInt(second / (60 * 60 * 24));
      var hour = parseInt(second % (60 * 60 * 24) / (60 * 60));
      var minute = parseInt(second % (60 * 60) / 60);

      if (day > 0) {
        text += day + '天';
        return text;
      }

      if (hour > 0) {
        text += hour + '小时' + minute + '分钟';
        return text;
      }

      if (minute > 0) {
        text += minute + '分钟';
        return text;
      }

      return '已到预约时间';
    },
    updateTime: function updateTime() {
      var _this = this;

      setTimeout(function () {
        _this.nowTime += 10;

        _this.updateTime();
      }, 10000);
    }
  },
  mounted: function mounted() {
    this.$slots['temp-icon'] && (this.hasTempIcon = true);
    this.$slots['no'] && (this.hasNo = true);
    this.$slots['time'] && (this.hasTime = true);
    this.$slots['customer'] && (this.hasCustomer = true);
    this.$slots['address'] && (this.hasAddress = true); // if (this.time) {
    //   this.updateTime()
    // }
  }
};